import styled from 'styled-components';

export const EachDiv = styled.div`
  margin-top: ${({ theme }) => theme.spacing.m};
  width: 100%;
  height: auto;
  padding: ${({ theme }) => theme.spacing.m};
  border-radius: ${({ theme }) => theme.borderRadius};
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  text-transform: capitalize;
  box-shadow: ${({ theme }) => theme.shadows.shadow2};
  transition: all 0.3s ease-in-out;

  h5 {
    color: ${({ theme }) => theme.colors.grey6};
    font-size: ${({ theme }) => theme.spacing.m};
    margin: 0;
    /* letter-spacing: 0.05rem; */
    letter-spacing: 0;
    transition: color 0.3s ease-in-out;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey4};
    transform: scale(1.02);
    box-shadow: ${({ theme }) => theme.shadows.shadow3};
    h5 {
      color: ${({ theme }) => theme.colors.orange4};
    }
  }
`;
